import React from 'react';
import { Navigate } from 'react-router-dom';
import { decodeToken } from './decodeToken';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token'); // Get token from localStorage
  let isAuthenticated = false;

  if (token) {
    try {
      const decodedToken = decodeToken(token);
      // Check if the token is still valid
      isAuthenticated = decodedToken.exp * 1000 > Date.now();
      if (!isAuthenticated) {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('token');
      }
    } catch (error) {
      localStorage.removeItem('currentUser');
      localStorage.removeItem('token');
      console.error('Invalid token', error);
    }
  }

  return isAuthenticated ? children : <Navigate to="/auth/sign-in" replace />;
};

export default ProtectedRoute;
